import { ControlAttributeType } from "@cloudpivot/form/typings";
import { formatterValueToSetStatus, formatterRequiredFormula } from "@cloudpivot/form/utils";
import baseAttribute from "@cloudpivot/form/src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "visible", "style", "tips", "dataItemName"],
        },
        controller: {
            label: "控件属性",
            keys: ["defaultValue", "displayFormula", "requiredFormula", "readonlyFormula", "maxLength", "placeholder", "currentMaxLength", "description", "prompt", "temperature", "maxTokens"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        prompt: {
            inputMethod: ControlAttributeType.String,
        },
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("@cloudpivot/form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("@cloudpivot/form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
    },
};
